export const common = {
  nav: {
    home: 'Trang chủ',
    about: 'Giới thiệu',
    rooms: 'Phòng',
    gallery: 'Thư viện ảnh',
    reservation: 'Đặt phòng',
    access: 'Hướng dẫn đến',
    contact: 'Liên hệ',
    forOwners: 'Dành cho chủ nhà',
    freeConsultation: 'Tư vấn miễn phí',
  },
  hero: {
    title: 'Nơi truyền thống gặp gỡ',
    subtitle: 'Tiện nghi hiện đại',
    description: 'Trải nghiệm vẻ đẹp chân thực của ngôi nhà Nhật Bản truyền thống tại Magome, quận Ota, Tokyo. Sự kết hợp hoàn hảo giữa vẻ đẹp lịch sử và tiện nghi đương đại.',
    bookNow: 'Đặt ngay',
    viewGallery: 'Xem thư viện ảnh',
  },
  about: {
    title: 'Giới thiệu',
    subtitle: 'Sự hòa quyện hài hòa giữa kiến trúc Nhật Bản truyền thống và tiện nghi hiện đại',
    description: 'Nhà truyền thống Magome là một ngôi nhà Nhật Bản được phục dựng đẹp đẽ tọa lạc tại khu dân cư yên tĩnh Magome, quận Ota, Tokyo. Được cải tạo cẩn thận để bảo tồn vẻ đẹp truyền thống trong khi cung cấp tiện nghi hiện đại, mang đến cơ hội độc đáo để trải nghiệm cuộc sống Nhật Bản đích thực.',
    feature1Title: 'Thuê nguyên căn',
    feature1Desc: 'Tận hưởng sự riêng tư hoàn toàn cùng gia đình và bạn bè',
    feature2Title: 'Bếp đầy đủ tiện nghi',
    feature2Desc: 'Bếp được trang bị đầy đủ để nấu những món ăn yêu thích của bạn',
    feature3Title: 'Tối đa 8 khách',
    feature3Desc: 'Chỗ ở rộng rãi hoàn hảo cho nhóm và gia đình',
    feature4Title: 'Tatami truyền thống',
    feature4Desc: 'Phòng Nhật Bản chính thống với chiếu tatami và hơi ấm của gỗ',
  },
  rooms: {
    title: 'Phòng',
    subtitle: 'Thư giãn trong không gian Nhật Bản truyền thống',
    room1: 'Sơ đồ mặt bằng',
    room2: 'Bếp đầy đủ',
    room3: 'Giường phụ',
    capacity: 'Sức chứa tối đa',
    guests: '8 khách',
    amenities: 'Tiện nghi',
    amenitiesList: 'Bếp đầy đủ, Tủ lạnh, Lò vi sóng, Dụng cụ nấu ăn, Bát đĩa, Wi-Fi, Điều hòa, Sưởi ấm, Máy giặt, Phòng tắm, Nhà vệ sinh, Khăn tắm, Đồ dùng vệ sinh cá nhân',
  },
  gallery: {
    title: 'Thư viện ảnh',
    subtitle: 'Khám phá vẻ đẹp của Nhà truyền thống Magome',
  },
  reservation: {
    title: 'Đặt phòng',
    subtitle: 'Đặt kỳ nghỉ đặc biệt của bạn',
    name: 'Họ và tên',
    email: 'Địa chỉ email',
    phone: 'Số điện thoại',
    checkin: 'Nhận phòng',
    checkout: 'Trả phòng',
    guests: 'Số lượng khách',
    message: 'Yêu cầu đặc biệt',
    submit: 'Gửi yêu cầu đặt phòng',
    submitting: 'Đang gửi...',
    success: 'Yêu cầu đặt phòng của bạn đã được nhận. Chúng tôi sẽ liên hệ sớm.',
    error: 'Gửi thất bại. Vui lòng thử lại.',
    bookingPlatforms: 'Bạn cũng có thể đặt qua các nền tảng này',
    bookOnAirbnb: 'Kiểm tra tình trạng phòng & đặt trên Airbnb',
    bookOnJalan: 'Kiểm tra tình trạng phòng & đặt trên Jalan',
    orDirectBooking: 'hoặc liên hệ trực tiếp với chúng tôi',
    required: 'Bắt buộc',
    guestsPlaceholder: '― Vui lòng chọn ―',
    guestSingular: 'Khách',
    guestPlural: 'Khách',
    messagePlaceholder: 'Có yêu cầu đặc biệt hoặc câu hỏi? Hãy cho chúng tôi biết. (tối đa 500 ký tự)',
    confirmNote: '※ Chúng tôi sẽ liên hệ sau khi xác nhận yêu cầu đặt phòng của bạn.',
  },
  contact: {
    title: 'Liên hệ',
    subtitle: 'Hãy liên hệ nếu bạn có bất kỳ câu hỏi hoặc thắc mắc nào',
    name: 'Họ và tên',
    email: 'Địa chỉ email',
    subject: 'Chủ đề',
    message: 'Tin nhắn',
    submit: 'Gửi',
    submitting: 'Đang gửi...',
    success: 'Tin nhắn của bạn đã được nhận. Chúng tôi sẽ liên hệ sớm.',
    error: 'Gửi thất bại. Vui lòng thử lại.',
    address: 'Địa chỉ',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'Hướng dẫn đến',
    accessDetail: 'Đi bộ 8 phút từ ga Magome (Toei Asakusa Line)',
    faqBannerTitle: 'Trước khi gửi, hãy xem FAQ của chúng tôi',
    faqBannerDesc: 'Chúng tôi đã trả lời nhiều câu hỏi phổ biến về giá cả, thủ tục và quản lý.',
    faqBannerBtn: 'Xem FAQ',
    accessInfoTitle: 'Thông tin hướng dẫn đến',
    sendMessageTitle: 'Gửi tin nhắn',
    inquiryType: 'Loại yêu cầu',
    inquiryTypePlaceholder: 'Chọn loại yêu cầu',
    inquiryOptions: {
      minpaku: 'Đăng ký Minpaku / Xin giấy phép',
      ryokan: 'Xin giấy phép Ryokan',
      management: 'Quản lý tài sản / Vận hành',
      pricing: 'Giá cả / Gói dịch vụ',
      marketing: 'Danh sách Airbnb / Marketing',
      revenue: 'Mô phỏng doanh thu',
      other: 'Khác',
    },
    messagePlaceholder: 'Vui lòng mô tả yêu cầu của bạn (tối đa 500 ký tự)',
    detailLabel: 'Chi tiết tư vấn',
    detailPlaceholder: 'Vui lòng mô tả vị trí, tình trạng hiện tại và yêu cầu của bạn (tối đa 500 ký tự)',
  },
  access: {
    label: 'Hướng dẫn đến',
    title: 'Hướng dẫn đến & Bản đồ',
    subtitle: 'Tọa lạc tại khu dân cư yên tĩnh Higashi-Magome, quận Ota, Tokyo',
    addressLabel: 'Địa chỉ',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'Bằng tàu điện',
    trainLine1: 'Đi bộ 2 phút từ ga Magome (Toei Asakusa Line)',
    trainLine2: '',
    busLabel: 'Bằng xe buýt',
    busLine1: 'Đi bộ 2 phút từ trạm xe buýt "Magome Ekimae" (Toei Bus)',
    busLine2: '',
    parkingLabel: 'Bãi đỗ xe',
    parkingLine1: 'Có bãi đỗ xe trả tiền gần đó',
    parkingLine2: 'Vui lòng liên hệ nếu bạn đến bằng ô tô',
    openMap: 'Mở trong Google Maps',
  },
  footer: {
    description: 'Cho thuê nguyên căn nhà truyền thống Nhật Bản tại Magome, quận Ota, Tokyo. Trải nghiệm sự hòa quyện hoàn hảo giữa vẻ đẹp Nhật Bản và tiện nghi hiện đại.',
    quickLinks: 'Liên kết nhanh',
    followUs: 'Theo dõi chúng tôi',
    rights: 'Bảo lưu mọi quyền.',
    napTitle: 'Văn phòng Yokota — Kế toán & Thuế',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'Điện thoại: Vui lòng liên hệ',
    napServiceArea: 'Khu vực phục vụ: Ota City và toàn Tokyo',
    napAccess: 'Toei Asakusa Line — Ga Magome',
  },
  stickyButton: {
    title: 'Tư vấn 30 phút',
    subtitle: 'Miễn phí',
  },
  ownersBanner: {
    subtitle: 'Dành cho chủ nhà đang cân nhắc Airbnb tại Tokyo',
    linkText: 'Tìm hiểu về dịch vụ hỗ trợ cho chủ nhà →',
  },
  airbnbLead: {
    title: 'Bạn đang nghĩ đến việc bắt đầu Airbnb tại Tokyo?',
    description: 'Chúng tôi cung cấp hỗ trợ toàn diện — từ đăng ký Minpaku và xin giấy phép Ryokan đến quản lý tài sản đầy đủ. Có trụ sở tại thành phố Ota với kinh nghiệm vận hành thực tế.',
    ctaButton: 'Nhận tư vấn miễn phí',
    badge1: 'Tư vấn không ràng buộc',
    badge2: 'Kinh nghiệm vận hành thực tế',
    badge3: 'Hỗ trợ toàn diện từ cấp phép đến quản lý',
  },
  trust: {
    badge: 'Tại sao chọn chúng tôi',
    title: 'Được tin tưởng bởi chủ nhà tại Tokyo',
    subtitle: 'Chúng tôi kết hợp kinh nghiệm vận hành thực tế với hỗ trợ toàn diện để giúp bạn thành công.',
    point1Title: 'Kinh nghiệm Airbnb thực tế',
    point1Description: 'Chúng tôi tích cực vận hành chỗ ở truyền thống của riêng mình tại thành phố Ota. Lời khuyên của chúng tôi dựa trên kinh nghiệm thực tế, không phải lý thuyết.',
    point2Title: 'Hỗ trợ cấp phép toàn diện',
    point2Description: 'Từ đăng ký Minpaku đến xin giấy phép Ryokan — chúng tôi xử lý tất cả giấy tờ và liên lạc với cơ quan chức năng.',
    point3Title: 'Tối ưu hóa doanh thu',
    point3Description: 'Chiến lược định giá dựa trên dữ liệu thị trường Tokyo thực tế. Doanh thu tăng trung bình 30%+ cho khách hàng của chúng tôi.',
    point4Title: 'Hỗ trợ khách 24/7',
    point4Description: 'Giao tiếp với khách đa ngôn ngữ suốt ngày đêm để bạn tập trung vào thu nhập, không phải quản lý.',
    point5Title: 'Báo cáo minh bạch',
    point5Description: 'Báo cáo doanh thu hàng tháng và cấu trúc phí rõ ràng. Không có chi phí ẩn, không có bất ngờ.',
    ctaButton: 'Khám phá dịch vụ của chúng tôi',
  },
  howItWorks: {
    title: 'Cách thức hoạt động',
    subtitle: 'Quy trình đơn giản, minh bạch từ tư vấn đến ra mắt thành công',
    step1Number: '01',
    step1Title: 'Tư vấn miễn phí',
    step1Desc: 'Chia sẻ thông tin tài sản và mục tiêu của bạn. Chúng tôi cung cấp lời khuyên trung thực về cấp phép, tiềm năng doanh thu và các bước tiếp theo.',
    step2Number: '02',
    step2Title: 'Đánh giá tài sản',
    step2Desc: 'Chúng tôi đánh giá sự phù hợp của tài sản, xác định yêu cầu và tạo kế hoạch hành động tùy chỉnh.',
    step3Number: '03',
    step3Title: 'Ra mắt & Hỗ trợ',
    step3Desc: 'Từ nộp đơn xin giấy phép đến quản lý khách, chúng tôi xử lý mọi thứ để bạn tập trung vào thu nhập.',
    ctaButton: 'Đặt lịch tư vấn miễn phí',
    ctaNote: '30 phút • Không ràng buộc • Lộ trình rõ ràng',
  },
  urgency: {
    title: 'Bạn đang nghĩ đến việc bắt đầu Airbnb tại Tokyo?',
    description: 'Quy tắc cấp phép phức tạp và sai lầm có thể làm chậm việc ra mắt của bạn. Nhận lời khuyên rõ ràng, thực tế trước khi đưa ra quyết định.',
    ctaButton: 'Đặt tư vấn miễn phí',
    note: 'Tư vấn 30 phút • Không ràng buộc • Kinh nghiệm thực tế',
  },
  trustRisk: {
    title: 'Tư vấn không áp lực',
    description: 'Chúng tôi cung cấp lời khuyên thực tế dựa trên kinh nghiệm thực tế. Ngay cả khi bạn quyết định không tiến hành, bạn sẽ nhận được lộ trình rõ ràng.',
    badge1Title: 'Không ràng buộc',
    badge1Desc: 'Lời khuyên miễn phí không áp lực',
    badge2Title: 'Kinh nghiệm thực tế',
    badge2Desc: 'Chúng tôi vận hành tài sản của riêng mình',
    badge3Title: 'Lộ trình rõ ràng',
    badge3Desc: 'Hướng dẫn có thể áp dụng ngay',
    whatYouGetTitle: 'Những gì bạn sẽ nhận được từ tư vấn của chúng tôi',
    item1: 'Đánh giá trung thực về tiềm năng tài sản của bạn',
    item2: 'Giải thích rõ ràng về yêu cầu cấp phép và thời gian',
    item3: 'Dự báo doanh thu thực tế dựa trên vị trí của bạn',
    item4: 'Lộ trình từng bước bạn có thể tự thực hiện',
    ctaButton: 'Lên lịch tư vấn miễn phí',
    ctaNote: 'Thứ Hai–Thứ Sáu, 9:00–18:00 JST',
  },
  faq: {
    title: 'Câu hỏi thường gặp',
    subtitle: 'Các câu hỏi phổ biến về việc bắt đầu và vận hành kinh doanh Airbnb và Minpaku tại Tokyo',
    ctaText: 'Có thêm câu hỏi? Chúng tôi sẵn sàng giúp đỡ.',
    ctaButton: 'Đặt tư vấn miễn phí',
    q1: 'Làm thế nào để bắt đầu Airbnb tại Tokyo?',
    a1: 'Bắt đầu Airbnb tại Tokyo yêu cầu phải có giấy phép phù hợp. Bạn có hai lựa chọn chính: đăng ký Minpaku (nhà ở dân cư) hoặc giấy phép Ryokan (nhà trọ đơn giản). Minpaku cho phép hoạt động tối đa 180 ngày mỗi năm và yêu cầu đăng ký với cơ quan địa phương. Giấy phép Ryokan cho phép hoạt động quanh năm nhưng yêu cầu đáp ứng các tiêu chuẩn cơ sở vật chất và quy định an toàn phòng cháy chữa cháy nghiêm ngặt hơn.',
    q2: 'Sự khác biệt giữa Minpaku và giấy phép Ryokan là gì?',
    a2: 'Minpaku là đăng ký nhà ở dân cư cho phép chủ nhà cho thuê nhà tối đa 180 ngày mỗi năm. Yêu cầu đơn giản hơn nhưng có giới hạn hoạt động. Ryokan là giấy phép kinh doanh nhà trọ đơn giản cho phép hoạt động quanh năm không giới hạn ngày. Tuy nhiên, yêu cầu đáp ứng các tiêu chuẩn cơ sở vật chất, thiết bị an toàn phòng cháy và kiểm tra định kỳ nghiêm ngặt hơn.',
    q3: 'Người nước ngoài có thể bắt đầu Airbnb tại Nhật Bản không?',
    a3: 'Có, người nước ngoài có thể bắt đầu kinh doanh Airbnb tại Nhật Bản, nhưng có những yêu cầu quan trọng. Bạn phải có tư cách cư trú phù hợp cho phép hoạt động kinh doanh tại Nhật Bản. Cần có quyền sở hữu tài sản hoặc hợp đồng thuê hợp lệ, và bạn phải chỉ định đại diện quản lý cư trú tại Nhật Bản có thể phản hồi các vấn đề trong vòng 30 phút.',
    q4: 'Đăng ký Minpaku tại Tokyo mất bao lâu?',
    a4: 'Đăng ký Minpaku tại Tokyo thường mất 2-4 tháng từ khi chuẩn bị ban đầu đến khi được phê duyệt. Thời gian bao gồm: đánh giá và chuẩn bị tài sản (2-3 tuần), chuẩn bị tài liệu và kiểm tra an toàn phòng cháy (2-4 tuần), nộp cho chính quyền địa phương (xử lý 1-2 tuần) và phê duyệt và đăng ký cuối cùng (1-2 tuần).',
    q5: 'Chi phí để bắt đầu là bao nhiêu?',
    a5: 'Chi phí thay đổi tùy thuộc vào phạm vi dịch vụ và tình trạng tài sản của bạn. Chúng tôi cung cấp các gói bao gồm hỗ trợ nộp đơn, chuẩn bị tài liệu và đánh giá tại chỗ. Đối với dịch vụ quản lý tài sản, chúng tôi sử dụng cấu trúc phí dựa trên hiệu suất — một tỷ lệ phần trăm doanh thu — để bạn có thể bắt đầu với chi phí trả trước tối thiểu.',
    q6: 'Bạn có thể xử lý gì nếu tôi thấy tự quản lý khó khăn?',
    a6: 'Chúng tôi có thể xử lý mọi thứ — quản lý đặt phòng, giao tiếp với khách, điều phối dọn dẹp, bàn giao chìa khóa, giải quyết vấn đề và báo cáo doanh thu hàng tháng. Chủ nhà về cơ bản có thể vận hành Airbnb mà không cần tự tay làm.',
    q7: 'Tôi có thể chạy Airbnb trong căn hộ chung cư không?',
    a7: 'Chạy Airbnb trong căn hộ chung cư là có thể miễn là không bị cấm bởi quy tắc quản lý tòa nhà. Trước tiên bạn cần kiểm tra quy định quản lý để xác nhận không có điều khoản nào cấm hoạt động lưu trú hoặc cho thuê ngắn hạn.',
    q8: 'Tôi lo lắng về khiếu nại từ hàng xóm. Bạn xử lý điều đó như thế nào?',
    a8: 'Chúng tôi đặt ra các quy tắc nhà rõ ràng cho khách (tiếng ồn, xử lý rác, sử dụng khu vực chung, v.v.) và giải thích cẩn thận khi nhận phòng để ngăn ngừa vấn đề trước khi xảy ra. Nếu có khiếu nại xảy ra, chúng tôi có hệ thống phản hồi 24 giờ để đánh giá và giải quyết tình huống nhanh chóng.',
    q9: 'Tôi có thể kỳ vọng doanh thu bao nhiêu?',
    a9: 'Doanh thu thay đổi đáng kể tùy thuộc vào vị trí, quy mô, tiện nghi và tỷ lệ lấp đầy của tài sản. Ở các khu vực phổ biến của Tokyo, tài sản 1LDK đến 2LDK có thể tạo ra doanh thu hàng tháng ¥200,000–¥500,000 trong một số trường hợp. Chúng tôi cung cấp mô phỏng doanh thu miễn phí dựa trên dữ liệu vận hành trong quá khứ của chúng tôi.',
    q10: 'Chỉ tư vấn thôi có được không? Tôi có bị ép ký hợp đồng không?',
    a10: 'Hoàn toàn được — chỉ tư vấn thôi rất được hoan nghênh. Chúng tôi không bao giờ ép bạn ký hợp đồng ngay lập tức. Chúng tôi hy vọng bạn sẽ dành thời gian và đưa ra quyết định theo nhịp độ của riêng mình.',
  },
  seo: {
    home: {
      title: 'Magome Kominka | Nhà Truyền Thống Nhật Bản Tokyo & Quản Lý Airbnb',
      description: 'Lưu trú tại nhà truyền thống Nhật Bản ở Magome, Ota-ku, Tokyo — thuê nguyên căn tối đa 8 người. Quản lý Airbnb chuyên nghiệp và hỗ trợ giấy phép minpaku bởi các host đang hoạt động.',
      keywords: 'Magome Kominka, Tokyo Airbnb, Ota City minpaku, nhà truyền thống Nhật Bản, cho thuê ngắn hạn Tokyo',
    },
    management: {
      title: 'Dịch Vụ Quản Lý Airbnb Tokyo | Cho Thuê Ngắn Hạn Toàn Diện',
      description: 'Quản lý Airbnb chuyên nghiệp tại Tokyo. Giao tiếp khách, định giá động, điều phối dọn dẹp và báo cáo hàng tháng. Quản lý cho thuê ngắn hạn toàn diện cho chủ nhà ở Ota City và Tokyo.',
      keywords: 'quản lý Airbnb Tokyo, cho thuê ngắn hạn Tokyo, quản lý bất động sản Ota City, dịch vụ khách Tokyo',
    },
    support: {
      title: 'Hỗ Trợ Minpaku & Giấy Phép Ryokan Tokyo | Khởi Nghiệp Kinh Doanh Lưu Trú',
      description: 'Hỗ trợ chuyên nghiệp đăng ký minpaku và xin giấy phép ryokan tại Tokyo. Hướng dẫn thực tế từ các host đang hoạt động ở Ota City — từ thủ tục hành chính đến ra mắt doanh thu.',
      keywords: 'đăng ký minpaku Tokyo, giấy phép ryokan Tokyo, hỗ trợ Airbnb Tokyo, cho thuê ngắn hạn Ota City',
    },
    forOwners: {
      title: 'Quản Lý Airbnb Tokyo & Hỗ Trợ Giấy Phép Minpaku Cho Chủ Nhà',
      description: 'Quản lý Airbnb toàn diện và hỗ trợ giấy phép minpaku cho chủ nhà tại Tokyo. Từ cấp phép đến vận hành hàng ngày và dọn dẹp — hỗ trợ đầy đủ. Tư vấn miễn phí.',
      keywords: 'chủ nhà Airbnb Tokyo, hỗ trợ giấy phép minpaku, quản lý bất động sản Tokyo, Airbnb Ota City',
    },
    pricing: {
      title: 'Bảng Giá Quản Lý Airbnb Tokyo | Gói Dịch Vụ Minh Bạch',
      description: 'Bảng giá rõ ràng, minh bạch cho quản lý Airbnb và hỗ trợ minpaku tại Tokyo. Gói hỗ trợ khởi nghiệp, thiết lập đầy đủ, dịch vụ quản lý và dọn dẹp. Không phí ẩn.',
      keywords: 'giá quản lý Airbnb Tokyo, chi phí hỗ trợ minpaku, gói cho thuê ngắn hạn Tokyo, phí quản lý Tokyo',
    },
    minpakuRegistration: {
      title: 'Đăng Ký Minpaku Tokyo | Hướng Dẫn Từng Bước Giấy Phép Ryokan',
      description: 'Hướng dẫn đầy đủ đăng ký minpaku tại Tokyo. Quy trình xin giấy phép ryokan, tài liệu cần thiết, lịch trình và lỗi thường gặp — dựa trên kinh nghiệm thực tế tại Ota City.',
      keywords: 'đăng ký minpaku Tokyo, giấy phép ryokan Tokyo, hỗ trợ Airbnb Tokyo, cho thuê ngắn hạn Ota City',
    },
    guide: {
      title: 'Hướng Dẫn Khởi Nghiệp Minpaku Tokyo 2026 | Giấy Phép, Doanh Thu & Quản Lý',
      description: 'Hướng dẫn đầy đủ để bắt đầu kinh doanh Airbnb tại Tokyo. Minpaku vs Ryokan, các bước cấp phép, lịch trình, lỗi thường gặp, ước tính doanh thu và khi nào nên dùng dịch vụ quản lý.',
      keywords: 'hướng dẫn minpaku Tokyo, bắt đầu Airbnb Tokyo, giấy phép minpaku, giấy phép ryokan, cho thuê ngắn hạn Tokyo',
    },
    caseStudy: {
      title: 'Case Study Khởi Nghiệp Minpaku Ota City | Câu Chuyện Thành Công Airbnb Tokyo',
      description: 'Case study thực tế: Chủ nhà ở Ota City ra mắt Airbnb trong 3,5 tháng với giấy phép Ryokan, đạt ¥180.000+/tháng và tỷ lệ lấp đầy 78%. Hỗ trợ minpaku Tokyo trong thực tế.',
      keywords: 'Ota City minpaku, case study Airbnb Tokyo, giấy phép ryokan Tokyo, quản lý Airbnb Tokyo',
    },
    adsLanding: {
      title: 'Khởi Nghiệp Airbnb Hợp Pháp Tại Tokyo | Hỗ Trợ Giấy Phép Minpaku & Ryokan',
      description: 'Hỗ trợ chuyên nghiệp giấy phép minpaku và ryokan tại Tokyo. Quản lý Airbnb toàn diện từ các host đang hoạt động ở Ota City. Tư vấn miễn phí 30 phút. Hỗ trợ khởi nghiệp từ ¥300.000.',
      keywords: 'Airbnb hợp pháp Tokyo, hỗ trợ giấy phép minpaku, xin ryokan Tokyo, khởi nghiệp Airbnb Ota City',
    },
    airbnbGuide: {
      title: 'Hướng Dẫn Pháp Lý Airbnb Tokyo | Hướng Dẫn Đầy Đủ Giấy Phép Minpaku & Ryokan',
      description: 'Hướng dẫn đầy đủ để bắt đầu Airbnb hợp pháp tại Tokyo. Đăng ký Minpaku, yêu cầu giấy phép Ryokan, chi phí, lịch trình và quy trình từng bước — dựa trên kinh nghiệm thực tế tại Ota City.',
      keywords: 'giấy phép Airbnb Tokyo, đăng ký minpaku Tokyo, giấy phép ryokan Tokyo, quản lý Airbnb Tokyo, cho thuê ngắn hạn Ota City',
    },
  },
  schema: {
    management: {
      offerDescription: '15%–20% doanh thu hàng tháng',
      service1: 'Điều chỉnh giá & định giá động',
      service2: 'Giao tiếp với khách (đa ngôn ngữ)',
      service3: 'Quản lý đánh giá',
      service4: 'Điều phối dọn dẹp & khăn trải giường',
      service5: 'Báo cáo doanh thu hàng tháng',
      service6: 'Chương trình hỗ trợ khai thuế',
    },
  },
  taxOffice: {
    badge: 'Văn phòng Kế toán & Thuế',
    sectionTitle: 'Văn phòng Yokota — Kế toán & Thuế',
    sectionSubtitle: 'Chuyên gia hỗ trợ thuế minpaku tại Higashi-Magome, Ota City, Tokyo',
    businessName: 'Văn phòng Yokota — Kế toán & Thuế',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'Địa chỉ',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'Khu vực phục vụ',
    serviceArea: 'Ota City và toàn Tokyo',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'Hướng dẫn đến',
    accessJa: 'Toei Asakusa Line — Ga Magome',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'Mở trong Google Maps',
    supportTitle: 'Hỗ trợ thuế Minpaku & Airbnb',
    supportItems: [
      'Hệ thống hỗ trợ khai thuế (không phải đại diện khai thuế)',
      'Hỗ trợ thuế minpaku tại Ota City',
      'Tư vấn thuế Airbnb Tokyo',
      'Hỗ trợ thuế minpaku Tokyo — tư vấn lần đầu miễn phí',
      'Tư vấn thuế Airbnb Tokyo — hỗ trợ khai báo thu nhập',
    ],
    disclaimer: '※ "Hệ thống hỗ trợ khai thuế" là hỗ trợ chuẩn bị hồ sơ và tư vấn, không phải đại diện khai thuế.',
    officeImageAlt: 'Văn phòng Yokota — Văn phòng kế toán tại Higashi-Magome, Ota City',
    officeImageCaption: 'Văn phòng Yokota — Higashi-Magome, Ota City, Tokyo',
    officeImageSubCaption: 'Hỗ trợ thuế minpaku Ota City · Tư vấn thuế Airbnb Tokyo',
  },
  managementContact: {
    title: 'Biểu mẫu tư vấn miễn phí',
    name: 'Họ và tên',
    nameRequired: 'Bắt buộc',
    phone: 'Số điện thoại',
    email: 'Địa chỉ email',
    emailRequired: 'Bắt buộc',
    propertyType: 'Loại bất động sản',
    propertyTypePlaceholder: 'Vui lòng chọn',
    propertyTypeOptions: {
      mansion1k: 'Căn hộ（Studio–1LDK）',
      mansion2ldk: 'Căn hộ（2LDK+）',
      house: 'Nhà riêng',
      kominka: 'Nhà truyền thống',
      taxConsult: 'Tư vấn thuế',
      other: 'Khác',
    },
    consultContent: 'Nội dung tư vấn',
    consultContentRequired: 'Bắt buộc',
    consultContentCounter: '{{count}}/500 ký tự',
    consultContentPlaceholder: 'Vui lòng mô tả vị trí, tình trạng hiện tại và yêu cầu của bạn（tối đa 500 ký tự）',
    submit: 'Đăng ký tư vấn miễn phí',
    submitting: 'Đang gửi...',
    success: 'Cảm ơn bạn đã liên hệ. Chúng tôi sẽ phản hồi trong vòng 2 ngày làm việc.',
    error: 'Gửi thất bại. Vui lòng thử lại.',
    beforeContact: 'Trước khi liên hệ',
    infoItems: [
      'Tư vấn lần đầu hoàn toàn miễn phí',
      'Chủ yếu phục vụ khu vực Tokyo',
      'Phản hồi trong 2 ngày làm việc',
      'Thông tin cá nhân được bảo mật nghiêm ngặt',
    ],
    recommendTitle: 'Chúng tôi khuyên bạn nên tư vấn nếu…',
    recommendItems: [
      'Có bất động sản nhưng không thể tự quản lý',
      'Muốn bắt đầu Minpaku như nghề phụ',
      'Không hài lòng với thu nhập hiện tại',
      'Đang tìm kiếm dịch vụ dọn dẹp',
      'Không biết cách sử dụng Airbnb',
    ],
    confirmNote: 'Sau khi xác nhận, nhân viên của chúng tôi sẽ liên hệ với bạn.',
  },
  privateDriver: {
    badge: 'Dịch Vụ Đối Tác',
    title: 'Tài Xế Riêng',
    titleEn: 'Private Driver Service',
    description: 'Các tài xế đối tác của chúng tôi cung cấp dịch vụ vận chuyển chuyên nghiệp — từ đưa đón sân bay đến các tour tham quan.',
    descriptionHighlight: 'Có tài xế nói tiếng Anh.',
    featureTitle: 'Tại Sao Chọn Dịch Vụ Của Chúng Tôi',
    features: [
      { title: 'Tài xế nói tiếng Anh', desc: 'Tài xế chuyên nghiệp nói tiếng Anh dành cho khách quốc tế.' },
      { title: 'An toàn & Có bảo hiểm', desc: 'Tài xế chuyên nghiệp được bảo hiểm đầy đủ đảm bảo chuyến đi an toàn và thoải mái.' },
      { title: 'Phục vụ 24/7', desc: 'Chuyến bay sáng sớm hay đến muộn đêm — chúng tôi luôn sẵn sàng khi đặt trước.' },
      { title: 'Hành lý lớn OK', desc: 'Xe lớn dành cho gia đình. Nhiều vali không thành vấn đề.' },
      { title: 'Lộ trình tùy chỉnh', desc: 'Lộ trình đặc biệt đến các điểm retro Showa và địa điểm chụp ảnh theo yêu cầu.' },
    ],
    menuTitle: 'Menu Dịch Vụ',
    priceGuide: 'Hướng Dẫn Giá',
    pricingTitle: 'Hướng Dẫn Giá',
    pricingNote: 'Tất cả giá đã bao gồm thuế. Chỉ là ước tính — liên hệ chúng tôi để có báo giá chính xác.',
    discountBadge: 'Ưu Đãi Độc Quyền',
    discountTitle: 'Chỉ Dành Cho Khách',
    discountOff: 'GIẢM 10%',
    discountSuffix: 'Ưu Đãi Đặc Biệt',
    discountNote: 'Đề cập đến kỳ lưu trú của bạn khi đặt để nhận ưu đãi.',
    discountBtn: 'Đặt Ngay',
    ctaBadge: 'Độc Quyền Cho Khách KOMINKA',
    ctaTitle: 'Giá Đặc Biệt Cho Khách',
    ctaDesc: 'Khách KOMINKA được hưởng ưu đãi độc quyền cho dịch vụ tài xế riêng của chúng tôi.',
    ctaBtn: 'Đặt Tài Xế',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: 'Đưa Đón Sân Bay', subtitle: '空港送迎', desc: 'Đón & trả sân bay Haneda/Narita. Dịch vụ meet & greet có sẵn.', price: 'Từ ¥8.000' },
      { title: 'Tour Thành Phố Tokyo', subtitle: '東京観光ドライブ', desc: 'Khám phá các khu phố thời Showa, đền chùa và điểm ẩn với tài xế địa phương.', price: 'Từ ¥15.000/3h' },
      { title: 'Hỗ Trợ Lưu Trú Dài Hạn', subtitle: '長期滞在サポート', desc: 'Dịch vụ tài xế hàng tuần hoặc hàng tháng cho mua sắm và các chuyến đi trong ngày.', price: 'Từ ¥40.000/tuần' },
      { title: 'Đi Đến Địa Điểm Chụp Ảnh', subtitle: '撮影ロケ送迎', desc: 'Vận chuyển đến các địa điểm thời Showa mang tính biểu tượng và địa điểm quay phim.', price: 'Từ ¥12.000/2h' },
    ],
    pricing: [
      { title: 'Đưa Đón Sân Bay', subtitle: 'Airport Transfer', rows: [{ label: 'Sân bay Haneda ⇔ Magome (một chiều)', price: '¥8.000+' }, { label: 'Sân bay Narita ⇔ Magome (một chiều)', price: '¥14.000+' }, { label: 'Phụ phí đêm (22:00–6:00)', price: '+¥2.000' }, { label: 'Hành lý lớn (3+ vali)', price: '+¥1.000' }], note: '* Giá như nhau cho tối đa 4 hành khách' },
      { title: 'Tour Thành Phố Tokyo', subtitle: 'Tokyo City Tour', rows: [{ label: 'Gói 3 giờ', price: '¥15.000+' }, { label: 'Gói 5 giờ', price: '¥22.000+' }, { label: 'Cả ngày (8 giờ)', price: '¥35.000+' }, { label: 'Lộ trình đặc biệt Showa Retro', price: '+¥3.000' }], note: '* Bao gồm phí hướng dẫn & đỗ xe' },
      { title: 'Đi Đến Địa Điểm Chụp Ảnh', subtitle: 'Photo Location Drive', rows: [{ label: 'Gói 2 giờ', price: '¥12.000+' }, { label: 'Gói 4 giờ', price: '¥20.000+' }, { label: 'Tùy chọn hướng dẫn địa điểm', price: '+¥2.000' }, { label: 'Xử lý thiết bị/hành lý lớn', price: '+¥1.500' }], note: '* Có thể tư vấn lộ trình trước' },
      { title: 'Hỗ Trợ Lưu Trú Dài Hạn', subtitle: 'Long Stay Support', rows: [{ label: 'Gói một lần/tuần (4 lần/tháng)', price: '¥40.000+' }, { label: 'Gói hai lần/tuần (8 lần/tháng)', price: '¥72.000+' }, { label: 'Sử dụng đơn lẻ (3 giờ)', price: '¥12.000+' }, { label: 'Mua sắm/bệnh viện', price: '¥6.000+/chuyến' }], note: '* Giảm 10% khi thanh toán hàng tháng' },
    ],
  },
};

export default common;
